import React from 'react';
import { useLocalization } from '@im/react-localization';
import { IngramLogo } from '@im/ui-lib/icons/IngramLogo';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useSiteConfig, useBuildVars } from 'mf_core/config';

export const IngramMobile = () => {
  const { siteCode } = useSiteConfig();
  const { buildEnvironment } = useBuildVars();

  const whitelistedCountries = ['us', 'ca'];
  const whitelistedEnv = ['staging', 'staging2', 'development'];

  const isNewHeader =
    whitelistedCountries.includes(siteCode) &&
    whitelistedEnv.includes(buildEnvironment);
  const iosLink =
    buildEnvironment === 'production'
      ? 'https://testflight.apple.com/join/jte4bnsP'
      : 'https://testflight.apple.com/join/aYWXKdbk';
  const anroidLink =
    buildEnvironment === 'production'
      ? 'https://play.google.com/apps/internaltest/4701580167084484765'
      : 'https://play.google.com/apps/internaltest/4700957448059632394';

  const { translate } = useLocalization();

  return (
    <>
      <Box padding={{ sm: 4, xs: '10px 15px' }}>
        <IngramLogo width="242" />
      </Box>
      <Box
        sx={{
          alignItems: 'center',
          bgcolor: '#f8f8f8',
          justifyContent: 'center',
          padding: '10px 20px',
          verticalAlign: 'middle',
        }}
      >
        {isNewHeader ? (
          <Box sx={{ textAlign: 'center' }}>
            <Typography sx={{ fontSize: '18px', fontWeight: 600 }}>
              {translate('MobileWeb.LoginPageDescriptionLine1')}
            </Typography>
            <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>
              {translate('MobileWeb.LoginPageDescriptionLine2')}
            </Typography>
            <Stack
              direction="row"
              spacing={1}
              sx={{ justifyContent: 'center', mt: '10px' }}
            >
              <a href={anroidLink}>
                <img
                  alt="google play"
                  src="/cep/assets/img/login/mobile-anroid-download.png"
                />
              </a>
              <a href={iosLink}>
                <img
                  alt="app store"
                  src="/cep/assets/img/login/mobile-ios-download.png"
                />
              </a>
            </Stack>
          </Box>
        ) : (
          <>
            <Typography
              align="center"
              color={(theme) => theme.palette.text.secondary}
              sx={{ fontSize: '24px', fontWeight: 400 }}
            >
              Please visit on a larger device
            </Typography>
            <Typography
              align="center"
              color={(theme) => theme.palette.text.secondary}
              sx={{ fontSize: '14px', fontWeight: 400 }}
            >
              Ingram Micro Xvantage isn't currently available for mobile devices
            </Typography>
          </>
        )}
      </Box>
      <Stack
        direction={{ sm: 'row', xs: 'column' }}
        justifyContent={{ sm: 'space-between', xs: 'start' }}
        sx={{
          backgroundImage: `url('/cep/assets/img/login/login-header.png')`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          height: 325,
        }}
      ></Stack>
      <Box>
        <Typography
          align="center"
          color={(theme) => theme.palette.text.secondary}
          padding={1}
          variant="body2"
        >
          {translate('OktaWidget.Copyright', {
            year: new Date().getFullYear().toString(),
          })}
        </Typography>
      </Box>
    </>
  );
};
